<script setup lang="ts">
import type { LawQuoteData } from '~/utils/crystallize/pieces'

defineProps<{ data: LawQuoteData }>()
</script>

<template>
  <blockquote class="my-xs">
    <span v-if="data.showSectionSymbol" class="text-blurple-300 font-semibold text-6xl font-heading float-left -translate-y-1/2 -mb-6 mr-7" aria-hidden="true">§</span>
    <CrystallizeRichText v-for="(block, i) in data.text" :key="i" :block="block" class="italic font-light title-blockquote mt-3 first-of-type:mt-0" />
  </blockquote>
</template>
